module.exports = __webpack_public_path__ + "img/BPT.435c8521.svg";